import { Accordion, Card, Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useSearchParams } from "react-router-dom";

import { ReactComponent as SortIcon } from "assets/images/icons/SortDown.svg";
import { QuotationFormStepTypes } from "constants/";
import Button from "components/atoms/Button/Button";
import { IQuotationData } from "pages/provider/QuotationDetail/QuotationType";
import RequestSummary from "./components/RequestSummary";
import FreightModeSummary from "./components/FreightModeSummary";
import FinancialSummary from "./components/FinancialSummary";
import ScheduleSumary from "./components/ScheduleSummary";
import ServiceConfirmationSumary from "./components/ServiceConfirmationSummary";
import AdditionalInformationSumary from "./components/AdditionalInformationSummary";
import { QuotationFormState } from "../../QuotationFormState";

type FormConfirmationProps = {
  state: QuotationFormState;
  isSubmitting: boolean;
  isSaving: boolean;
  onSubmit: () => void;
  onDraftSave: () => void;
  quoteRequestDetails: IQuotationData;
};

export default function FormConfirmation({
  state,
  isSubmitting,
  isSaving,
  onSubmit,
  onDraftSave,
  quoteRequestDetails,
}: FormConfirmationProps) {
  const [searchParams] = useSearchParams();
  const currentActiveStep = searchParams.get("active_step");

  return (
    <Card className="mb-3 form-container">
      <Accordion.Toggle as={Card.Header} className="accordion-header" eventKey={QuotationFormStepTypes.CONFIRMATION}>
        <div className="d-flex align-items-center">
          <h5>
            <FormattedMessage id="quotation-form.confirmation" defaultMessage="Confirmation" />
          </h5>
        </div>
        <SortIcon
          fill="#000"
          width={8}
          height={7}
          transform={`rotate(${currentActiveStep === QuotationFormStepTypes.CONFIRMATION ? 180 : 0})`}
        />
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={QuotationFormStepTypes.CONFIRMATION}>
        <Card.Body>
          <Row className="mb-5">
            <Col>
              <RequestSummary />
            </Col>
            <Col>
              <FreightModeSummary />
            </Col>
            <Col>
              <FinancialSummary state={state} />
            </Col>
          </Row>

          <Row>
            <Col>
              <ScheduleSumary quoteRequestDetails={quoteRequestDetails} />
            </Col>
            <Col>
              <ServiceConfirmationSumary />
            </Col>
            <Col>
              <AdditionalInformationSumary />
            </Col>
          </Row>

          <div className="d-flex justify-content-end mt-3xl mr-3xl mb-3xl">
            <Button variant="outline-primary" className="mr-lg" onClick={onDraftSave} disabled={isSubmitting || isSaving}>
              <FormattedMessage id="general.save" defaultMessage="Save" />
            </Button>
            <Button variant="primary" onClick={onSubmit} disabled={isSubmitting || isSaving}>
              <FormattedMessage id="general.submit" defaultMessage="Submit" />
            </Button>
          </div>
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
}
